import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ad1bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 下一代Serverless技术驱动的"),
          _hoisted_3,
          _createTextVNode(" 星汉未来AI应用平台——AIPilot ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('轻松管理不断涌现的AI应用与大模型，统一调度云端及本地的GPU、CPU等计算资源。' +
          'AIPilot支持大型模型推理，并已对接八家以上大模型厂商API，助力企业快速、高效、低成本的将AI融入多元生产场景。' +
          '基于众多专利技术，AIPilot能在一台8核16G的笔记本电脑上部署20个热门AI应用，企业只需万元成本，即可构建专属的AI应用引擎。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToWhiteBook()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费部署 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode("<a-button type=\"link\" class=\"button_n_1\""),
          _createCommentVNode("          @click=\"$Store.Page().openModal('modalFormCollection','demo')\">"),
          _createCommentVNode("  联系我们"),
          _createCommentVNode("</a-button>")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}